import React from "react";
import { useTranslation } from "react-i18next";

import "./AboutUsPage.css";
import { IMAGES } from "../utils/GetImages";
import { getTranslation } from "../utils/translation";

export default function AboutUsPage() {
	const { i18n } = useTranslation();

	const AboutUsImg1 = IMAGES["AboutUsPage-Img1.png"];
	const AboutUsImg2 = IMAGES["AboutUsPage-Img2.png"];
	const MissionStatementImg = IMAGES["AboutUsPage-MissionStatement.png"];

	return (
		<div className="about-container">
			<section id="about-wsom" className="about-us-section">
				<div className="about-us-container">
					<div className="about-us-content">
						<div className="about-us-text">
							<h2 className="about-us-title">
								{getTranslation(
									i18n,
									"homePage.aboutWSOM.title"
								)}
							</h2>
							<p className="about-us-paragraph">
								{getTranslation(
									i18n,
									"homePage.aboutWSOM.paragraph1"
								)}
							</p>
							<p className="about-us-paragraph">
								{getTranslation(
									i18n,
									"homePage.aboutWSOM.paragraph2"
								)}
							</p>
							<p className="about-us-paragraph">
								{getTranslation(
									i18n,
									"homePage.aboutWSOM.paragraph3"
								)}
							</p>
							<p className="about-us-signature">
								{getTranslation(
									i18n,
									"homePage.aboutWSOM.signature"
								)}
							</p>
						</div>
					</div>
				</div>
			</section>

			<section
				id="mission-statement"
				className="mission-statement-section"
			>
				<div className="mission-statement-container">
					<div className="mission-statement-content">
						<div className="mission-statement-image">
							<img
								src={MissionStatementImg}
								alt="World Series of Mahjong"
								className="mission-statement-img"
							/>
						</div>
						<div className="mission-statement-text">
							<h2 className="mission-statement-title">
								{getTranslation(
									i18n,
									"aboutUsPage.missionStatement.title"
								)}
							</h2>
							<p className="mission-statement-paragraph">
								{getTranslation(
									i18n,
									"aboutUsPage.missionStatement.paragraph1"
								)}
							</p>
							<p className="mission-statement-paragraph">
								{getTranslation(
									i18n,
									"aboutUsPage.missionStatement.paragraph2"
								)}
							</p>
						</div>
					</div>
				</div>
			</section>

			<section id="about-company" className="about-us-section">
				<div className="about-us-container">
					<div className="about-us-content">
						<div className="about-us-text">
							<h2 className="about-us-title">
								{getTranslation(
									i18n,
									"aboutUsPage.aboutCompany.title"
								)}
							</h2>
							<p className="about-us-paragraph">
								{getTranslation(
									i18n,
									"aboutUsPage.aboutCompany.paragraph"
								)}
							</p>
						</div>
						<div className="about-us-image">
							<div className="about-us-image-stack">
								<img
									src={AboutUsImg1}
									alt="World Series of Mahjong"
									className="about-us-img about-us-img-back"
								/>
								<img
									src={AboutUsImg2}
									alt="World Series of Mahjong"
									className="about-us-img about-us-img-front"
								/>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
	);
}
